export default __webpack_public_path__ + "static/media/library.a3617c3c.png";